import React from 'react';
import { Clapperboard } from 'lucide-react';
import { useLocale } from '../../contexts/LocaleContext';
import { ButtonTooltip, TooltipProvider } from '../ui/tooltip';
import { ScriptInfoStats, type ScriptInfoStatsLabels } from './ScriptInfoStats';

export function ScriptInfoIconWithTooltip({
  labels,
  className,
  style,
  triggerClassName = 'scene-heading-script-info-trigger',
  side = 'bottom',
  onMouseEnter,
}: {
  labels: ScriptInfoStatsLabels;
  className?: string;
  style?: React.CSSProperties;
  triggerClassName?: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
  onMouseEnter?: () => void;
}): React.ReactElement {
  const { t } = useLocale();

  return (
    <TooltipProvider delayDuration={200}>
      <div
        className={className}
        style={style}
        contentEditable={false}
        onMouseEnter={onMouseEnter}
        onMouseDown={(event) => {
          event.preventDefault();
        }}
      >
        <ButtonTooltip
          side={side}
          tooltip={{
            children: <ScriptInfoStats labels={labels} />,
            className: 'bg-popover text-popover-foreground border border-border shadow-md p-2',
          }}
        >
          <button
            type="button"
            className={triggerClassName}
            aria-label={t('script_info')}
          >
            <Clapperboard className="h-3.5 w-3.5" aria-hidden />
          </button>
        </ButtonTooltip>
      </div>
    </TooltipProvider>
  );
}
